import * as React from 'react';
import { Model, Question } from 'survey-core/survey.core';
import { SurveyQuestionElementBase } from 'survey-react-ui';
import { Box, Button } from '@material-ui/core';

export const TYPE = 'mui-complete-button';

export class MuiCompleteButtonModel extends Question {
  getType(): string {
    return TYPE;
  }
}

export class MuiCompleteButton extends SurveyQuestionElementBase {
  get question() {
    return this.questionBase;
  }

  get disabled() {
    const { survey } = this.question;

    const model = survey as Model;
    return model.getVariable('completeDisabled');
  }

  protected renderElement(): JSX.Element | null {
    const { survey } = this.question;
    const model = survey as Model;

    return (
      <Box mt={2.5}>
        <Button variant="contained" color="primary" disabled={this.disabled} onClick={() => model.completeLastPage()}>
          {model.completeText}
        </Button>
      </Box>
    );
  }
}
